import { createFileRoute, Link } from '@tanstack/react-router';
import { MarketingLayout } from '@/components/marketing/MarketingLayout';
import { Seo } from '@/components/marketing/Seo';
import { track } from '@/lib/analytics';

export const Route = createFileRoute('/support')({ component: SupportPage });

export function SupportPage() {
  return (
    <MarketingLayout screen="Support Screen">
      <Seo
        title="Support — Hmonglus"
        description="Get help with Hmonglus accounts, subscriptions, and learning content."
        path="/support"
      />
      <main className="grid place-items-center bg-sky-light px-6 pb-24 pt-32">
        <section className="w-full max-w-xl rounded-3xl bg-white p-8 shadow-sm">
          <h1 className="font-khula text-4xl font-light text-gray-900">How can we help?</h1>
          <p className="mt-4 leading-7 text-gray-600">
            For subscription, account, or learning-content questions, contact the Hmonglus team.
          </p>
          <Link
            to="/app/support"
            onClick={() => track('Landing CTA Press', { cta: 'support-chat' })}
            className="mt-7 inline-block rounded-lg bg-primary px-6 py-3 font-semibold text-white hover:bg-primary-hover"
          >
            Open support chat
          </Link>
          <p className="mt-6 text-sm text-gray-500">Your conversation follows your account when you sign in.</p>
        </section>
      </main>
    </MarketingLayout>
  );
}
